import { getCardStyles } from '@quno/onboarding/src/generator/configs/componentMapper';
import {
  defaultLocale,
  localeMapper,
} from '@quno/onboarding/src/constants/locales';
import { useTranslation } from '@quno/patient-journey/src/hooks/useTranslation';
import { TreatmentCard } from '@quno/patient-journey/src/components/Card/Variants/TreatmentCard';
import { Cta } from '@quno/patient-journey/src/components/Cta/Cta';
import { Base } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Base';
import type { TreatmentContainer } from '@quno/onboarding/src/generator/types/Models';
import type { FormLocales } from '@quno/patient-journey/src/constants/locales';

type TreatmentsProps = TreatmentContainer & {
  locale: FormLocales;
};

export const Treatments = (props: TreatmentsProps): JSX.Element => {
  const { locale: pageLocale } = useTranslation();
  const locale = props.locale || localeMapper[pageLocale] || defaultLocale;
  const { attributes } = props ?? {};

  const cardStyles = getCardStyles(props);
  const treatmentCards = attributes?.treatmentCards?.[defaultLocale];

  const hidePrice = attributes?.settings?.hidePrice?.[defaultLocale];

  return (
    <Base {...props}>
      <>
        {treatmentCards?.map((treatmentCard, index) => {
          const { product } = treatmentCard?.attributes ?? {};
          const backgroundColor = cardStyles?.card.backgroundColor;
          const borderRadius = cardStyles?.card.borderRadius;
          const fontColor = cardStyles?.card.fontColor;
          const cta = treatmentCard?.attributes?.cta?.[defaultLocale];

          return (
            <TreatmentCard
              key={index}
              productId={product?.[defaultLocale]}
              locale={locale}
              backgroundColorOverwrite={backgroundColor}
              fontColorOverride={fontColor}
              cardBorderRadius={borderRadius}
              imageBorderRadius={cardStyles?.image?.imageBorderRadius}
              cta={
                cta ? (
                  <Cta
                    {...cta}
                    additionalStyles={cardStyles.button}
                    locale={locale}
                  />
                ) : null
              }
              hidePrice={hidePrice}
            />
          );
        })}
      </>
    </Base>
  );
};
